import { type Flag, toFlagId } from '@atlassian/jira-flags/src/services/types';
import messages from './messages.tsx';

/**
 * Maps query-string IDs to `Flag`s
 */
type NotificationMessages = {
	[notificationId: string]: Flag;
};

export const notificationMessagesWithProjectTerm: NotificationMessages = {
	'jsw.board-not-found': {
		id: toFlagId('jsw.board-not-found'),
		type: 'error',
		title: messages.boardNotFound,
		description: messages.boardNotFoundDescription,
		messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found',
		messageType: 'transactional',
	},
	'jsw.project-not-found': {
		id: toFlagId('jsw.project-not-found'),
		type: 'error',
		title: messages.projectNotFound,
		description: messages.projectNotFoundDescription,
		messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found',
		messageType: 'transactional',
	},
};

export const notificationMessagesWithoutProjectTerm: NotificationMessages = {
	'jsw.board-not-found': {
		id: toFlagId('jsw.board-not-found'),
		type: 'error',
		title: messages.boardNotFound,
		description: messages.boardNotFoundDescription,
		messageId: 'query-string-notifier.common.flag.error.error.jsw.board-not-found.1',
		messageType: 'transactional',
	},
	'jsw.project-not-found': {
		id: toFlagId('jsw.project-not-found'),
		type: 'error',
		title: messages.projectNotFoundGalaxia,
		description: messages.projectNotFoundDescriptionGalaxia,
		messageId: 'query-string-notifier.common.flag.error.error.jsw.project-not-found.1',
		messageType: 'transactional',
	},
};
